// Lokalni (per-zarizeni) hlasitost - drive se musicVolume/buttonVolume tahaly jen ze serveroveho Trainer zaznamu (MusicPlayer.vue), jedna spolecna hodnota pro vsechna zarizeni uctu. Lokalni hodnota ma ted prednost, serverova (porad se uklada, viz SoundSettings.vue) je uz jen seed pro uplne nove zarizeni bez vlastni lokalni hodnoty. Scoped na trainer.id, protoze localStorage je sdileny napric ucty ve stejnem prohlizeci (stejna konvence jako tutorialFightStorage.js).
const STORAGE_KEY = 'pr.deviceVolume';

function readAll() {
    try {
        return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
    } catch (e) {
        return {};
    }
}

export function getStoredMusicVolume(trainerId, fallback) {
    const entry = readAll()[trainerId];
    return entry && typeof entry.music === 'number' ? entry.music : fallback;
}

export function getStoredButtonVolume(trainerId, fallback) {
    const entry = readAll()[trainerId];
    return entry && typeof entry.button === 'number' ? entry.button : fallback;
}

export function setStoredMusicVolume(trainerId, value) {
    const all = readAll();
    all[trainerId] = {...(all[trainerId] || {}), music: value};
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}

export function setStoredButtonVolume(trainerId, value) {
    const all = readAll();
    all[trainerId] = {...(all[trainerId] || {}), button: value};
    localStorage.setItem(STORAGE_KEY, JSON.stringify(all));
}
